<template>
  <a-modal
    :wrapClassName="disabled ? 'ps-see-form-modal' : ''"
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    :ok-text="saveText"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="年份" prop="acquireYear">
          <a-date-picker
            placeholder="请选择年份"
            :disabled="disabled"
            v-model="form.acquireYear"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            @change="handleClearAcquireYear"
          />
        </a-form-model-item>
        <a-form-model-item label="成果名称" prop="title">
          <a-input v-model="form.title" :disabled="disabled" />
        </a-form-model-item>
        <a-form-model-item label="级别" prop="levelType">
          <div class="flex">
            <a-select v-model="form.levelType" :disabled="disabled">
              <a-select-option
                :value="item.text"
                v-for="item in jblist"
                :key="item.text"
                >{{ item.title }}</a-select-option
              >
              <!-- <a-select-option value="其他" >{{
                item.title
              }}</a-select-option> -->
            </a-select>
            <template v-if="form.levelType == '其他'">
              <a-input
                v-model="form.otherType"
                :disabled="disabled"
                class="ipt-other"
              />
            </template>
          </div>
        </a-form-model-item>
        <!-- prop="amount" -->
        <a-form-model-item label="数量">
          <a-input-number
            v-model="form.amount"
            :disabled="disabled"
            min="1"
            precision="0"
            @blur="blurValue"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        title: "",
        acquireYear: "",
        achievementType: "",
        amount: "",
        levelType: "",
        content: "",
        courseType: "",
        otherType: "",
      },
      disabled: false,
      rules: {
        acquireYear: [
          {
            validator: (rule, value, callback) => {
              if (this.form.acquireYear != "") {
                callback(); // 验证通过
              } else {
                callback(new Error("请选择成果获得年份"));
              }
            },
            required: true,
            message: "请选择成果获得年份",
            //          type: 'string',
            trigger: "change",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入成果名称",
            trigger: "blur",
          },
        ],
        // achievementType: [
        //   {
        //     required: true,
        //     message: "请输入成果类型",
        //     trigger: "change",
        //   },
        // ],
        // amount: [
        //   {
        //     required: true,
        //     message: "请输入数量",
        //     trigger: "blur",
        //   },
        // ],
        levelType: [
          {
            required: true,
            message: "请选择级别",
            trigger: "change",
          },
        ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 1,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      jblist: [],
      kclist: [],
      ishow: false,
      ifirst: true,
      taskId: null,
      detailId: null,
      saveText: "保存",
      teacherdata: {},
    };
  },
  components: { BaseEditor },
  mounted() {
    // console.log("111111");
    // console.log(this.rules);
  },
  methods: {
    init(type, record, taskId, detailId) {
      this.type = type;
      this.visible = true;
      this.disabled = false;
      // this.getxwlist();
      this.getcgjb();
      // this.getkclist();
      if (type == "add") {
        this.form = {};
        this.form.applyId = record.id;
        this.form.acquireYear = new Date().getFullYear() + "";
        this.title = "新增成果";
      } else if (type == "edit") {
        this.title = "编辑成果";
        this.form = {
          title: record?.title,
          // achievementType: record.achievementType,
          amount: record.amount,
          levelType: record.levelType,
          courseType: record.courseType,
          applyId: record.applyId,
          acquireYear: record.acquireYear,
          id: record.id,
          content: record.content,
          otherType: record.otherType,
        };
        // if (record.amount == "1") {
        //   this.ifirst = true;
        // } else {
        //   this.ifirst = false;
        //   this.form.content = "";
        // }

        // if (record.achievementType == "SZKC") {
        //   this.ishow = true;
        // } else {
        //   this.ishow = false;
        //   this.form.courseType = "";
        // }
        //       if (record.content!='' && record.content!=null ){
        //           this.$nextTick(() => {
        //             this.$refs.baseEditor[0].value = record.content;
        //           })
        //       }
        this.teacherdata = record;
      } else if (type === "audit-edit") {
        this.title = "编辑成果";
        this.saveText = "提交";
        this.taskId = taskId;
        this.detailId = detailId;
        // 合并所有字段，确保编辑时能正确显示原有数据
        this.form = {
          title: record?.title,
          // achievementType: record.achievementType,
          amount: record.amount,
          levelType: record.levelType,
          courseType: record.courseType,
          applyId: record.applyId,
          acquireYear: record.acquireYear,
          id: record.id,
          content: record.content,
          otherType: record.otherType,
        };
      } else {
        this.title = "查看成果";
        this.disabled = true;
        this.saveText = "关闭";
        this.form = {
          title: record?.title,
          // achievementType: record.achievementType,
          amount: record.amount,
          levelType: record.levelType,
          courseType: record.courseType,
          applyId: record.applyId,
          acquireYear: record.acquireYear,
          id: record.id,
          content: record.content,
          otherType: record.otherType,
        };
        // if (record.amount == "1") {
        //   this.ifirst = true;
        // } else {
        //   this.ifirst = false;
        //   this.form.content = "";
        // }

        // if (record.achievementType == "SZKC") {
        //   this.ishow = true;
        // } else {
        //   this.ishow = false;
        //   this.form.courseType = "";
        // }
        //       if (record.content!='' && record.content!=null ){
        //           this.$nextTick(() => {
        //             this.$refs.baseEditor[0].value = record.content;
        //           })
        //       }
      }
    },
    blurValue() {
      if (this.form.amount == "1") {
        this.ifirst = true;
      } else {
        this.ifirst = false;
        this.form.content = "";
      }
    },
    handleClearAcquireYear(val) {
      this.form.acquireYear = ""; // 或者适当的空值，根据你的业务需求
      this.$forceUpdate();
    },
    handleChange() {
      console.log(this.form.achievementType);
      if (this.form.achievementType == "SZKC") {
        this.ishow = true;
      } else {
        this.ishow = false;
        this.form.courseType = "";
      }
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      const year = moment(value).format("YYYY");
      this.form.acquireYear = year + "";
      this.yearShowOne = false;
      // this.form.acquireYear = value;
      this.$refs.ruleForm.clearValidate("acquireYear");
      // this.yearShowOne = false;
    },
    handleCancel() {
      this.visible = false;
      //     this.yearShowOne = false;
    },
    getxwlist(ids) {
      getAction("/baseCommon/getDictItemsByCode?code=achievement_type").then(
        (res) => {
          if (res.code == 200) {
            this.xwlist = res.result;
          }
        }
      );
    },
    getcgjb() {
      getAction("/baseCommon/getDictItemsByCode?code=achievement_level").then(
        (res) => {
          if (res.code == 200) {
            this.jblist = res.result;
          }
        }
      );
    },
    getkclist() {
      getAction("/baseCommon/getDictItemsByCode?code=apply_course_type").then(
        (res) => {
          if (res.code == 200) {
            this.kclist = res.result;
          }
        }
      );
    },
    submit() {
      if (this.disabled) {
        this.visible = false;
        return false;
      }
      //  	this.$refs.ruleForm.clearValidate();
      if (
        typeof this.form.acquireYear == "object" &&
        this.form.acquireYear != "" &&
        this.type == "add"
      ) {
        this.form.acquireYear =
          new Date(this.form.acquireYear).getFullYear() + "";
      }
      this.$refs.ruleForm.validate((valid) => {
        //    	console.log(valid);
        if (valid) {
          //					this.yearShowOne = false;
          if (this.type == "add") {
            let params = this.form;
            //          params.acquireYear=new Date(this.form.acquireYear).getFullYear()+"";
            params.applyType = this.applyType;
            //params.applyId = "1829722136428707841";
            postAction("/lxBase/lxApplyAchievement/add", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("添加成功");
                this.$emit("addGain");
              } else {
                this.$message.error(res.message);
              }
            });
          } else if (this.type == "audit-edit") {
            let params = {
              taskId: this.taskId,
              afterJson: JSON.stringify({ ...this.form }),
              detailId: this.detailId,
            };
            postAction("/audit/lxAuditTask/reSubmitTask", params).then(
              (res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success(res.message || "编辑成功");
                  this.$emit("addGain");
                } else {
                  this.$message.error(res.message);
                }
              }
            );
          } else {
            if (
              this.teacherdata?.status == "1" ||
              this.teacherdata?.status == "4" ||
              this.teacherdata?.status == "0" ||
              this.teacherdata?.status == "3" ||
              (this.teacherdata?.status == "2" && this.teacherdata?.operation)
            ) {
              let params1 = this.form;
              //params.applyId = "1829722136428707841";
              if (typeof this.form.acquireYear == "object") {
                params1.acquireYear =
                  new Date(this.form.acquireYear).getFullYear() + "";
              }
              params1.applyType = this.applyType;
              let params = {
                id: this.teacherdata?.taskId,
                applicationData: JSON.stringify(this.$nullToEmpty(params1)),
              };
              if (this.teacherdata?.status == "4") {
                params.auditState = "1";
              }
              putAction("/audit/lxAuditTask/editTaskAndDetail", params).then(
                (res) => {
                  if (res.code == 200) {
                    this.visible = false;
                    this.$message.success("编辑成功");
                    this.$emit("addGain");
                  } else {
                    this.$message.error(res.message);
                  }
                }
              );
            } else {
              let params = this.form;
              //params.applyId = "1829722136428707841";
              if (typeof this.form.acquireYear == "object") {
                params.acquireYear =
                  new Date(this.form.acquireYear).getFullYear() + "";
              }
              params.applyType = this.applyType;
              putAction("/lxBase/lxApplyAchievement/edit", params).then(
                (res) => {
                  if (res.code == 200) {
                    this.visible = false;
                    this.$message.success("编辑成功");
                    this.$emit("addGain");
                  } else {
                    this.$message.error(res.message);
                  }
                }
              );
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
.ipt-other {
  margin-left: 12px;
}
</style>
